import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"

type Jid = string

export type GpsConfig = {
  driverJid: string
  deviceId: string
  driverId?: string
}

type GpsConfigState = Record<Jid, GpsConfig>

type BatchAddGpsConfigAction = { gpsConfigs: GpsConfig[] }
type AddGpsConfigAction = { gpsConfig: GpsConfig }
type RemoveGpsConfigAction = { driverJid: Jid }

const initialState: GpsConfigState = {}

const gpsConfigSlice = createSlice({
  name: "gpsConfig",
  initialState,
  reducers: {
    batchUpsertGpsConfigs: (
      state,
      action: PayloadAction<BatchAddGpsConfigAction>,
    ) => {
      action.payload.gpsConfigs.forEach((gpsConfig) => {
        state[gpsConfig.driverJid] = gpsConfig
      })
    },

    addGpsConfig: (state, action: PayloadAction<AddGpsConfigAction>) => {
      state[action.payload.gpsConfig.driverJid] = action.payload.gpsConfig
    },
    removeGpsConfig: (state, action: PayloadAction<RemoveGpsConfigAction>) => {
      delete state[action.payload.driverJid]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { batchUpsertGpsConfigs, addGpsConfig, removeGpsConfig } =
  gpsConfigSlice.actions

export default gpsConfigSlice.reducer
